var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('GomokuBoard'),_vm._m(1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('h1',[_vm._v("🎮 五子棋对战")]),_c('p',[_vm._v("体验经典五子棋乐趣")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("© 2024 五子棋对战 - 基于 Spring Boot + Vue")])])
}]

export { render, staticRenderFns }